import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { AppConfig, loadConfigJson } from './loadConfigJson';
import { setConfig } from './globalConfig';
import { initAppInsights } from '../../appInsights';

interface ConfigContextType {
  config: AppConfig | null;
  loading: boolean;
  error: string | null; // Add this line
}

const ConfigContext = createContext<ConfigContextType>({
  config: null,
  loading: true,
  error: null
});

// Config Provider Component
export const ConfigJsonProvider = ({ children }: { children: ReactNode }) => {
  const [config, setConfigState] = useState<AppConfig | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const appConfig = await loadConfigJson();
        setConfigState(appConfig);
        setConfig(appConfig);

        if (appConfig.connectionStringAppInsights) {
          initAppInsights(appConfig.connectionStringAppInsights);
        }
      } 
      catch (err) {
        setError('Failed to load configuration.');
        console.error(err);
      } 
      finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, []);

  return (
    <ConfigContext.Provider value={{ config, loading, error }}>
      {children}
    </ConfigContext.Provider>
  );
};

// Custom hook to use the Config Context
export const useConfig = () => useContext(ConfigContext);
